module.exports = __webpack_public_path__ + "static/img/download1-3.996017d0.png";